import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import { HIGHLIGHT_BG, NOTICE_WARNING_ICON, PAPER, withAlpha } from '../../styles/colors'
import { pointsToPx } from '../../../util/redaction/annotationMath'

const Highlight = styled.span`
  position: absolute;
  z-index: 3;
  pointer-events: none;
  box-sizing: border-box;
  border-radius: 2px;
  background: ${HIGHLIGHT_BG};
  mix-blend-mode: multiply;
  transition:
    background 120ms ease,
    box-shadow 120ms ease;

  &[data-active='true'] {
    background: ${withAlpha(NOTICE_WARNING_ICON, 0.62)};
    box-shadow:
      0 0 0 2px ${NOTICE_WARNING_ICON},
      0 0 0 4px ${withAlpha(PAPER, 0.8)};
  }
`

function DocumentSearchHighlights({ matches, activeIndex, scale }) {
  return matches.flatMap(match =>
    match.rects.map((rect, rectIndex) => {
      const position = pointsToPx(rect, scale)

      return (
        <Highlight
          key={`${match.index}-${rectIndex}`}
          data-testid="document-search-highlight"
          data-active={match.index === activeIndex ? 'true' : 'false'}
          style={position}
        />
      )
    })
  )
}

DocumentSearchHighlights.propTypes = {
  matches: PropTypes.arrayOf(
    PropTypes.shape({
      index: PropTypes.number.isRequired,
      rects: PropTypes.arrayOf(
        PropTypes.shape({
          x: PropTypes.number.isRequired,
          y: PropTypes.number.isRequired,
          w: PropTypes.number.isRequired,
          h: PropTypes.number.isRequired
        })
      ).isRequired
    })
  ).isRequired,
  activeIndex: PropTypes.number.isRequired,
  scale: PropTypes.number.isRequired
}

export default DocumentSearchHighlights
